import { render, staticRenderFns } from "./FormCheckboxBasic.vue?vue&type=template&id=7c0d0917&"
import script from "./FormCheckboxBasic.vue?vue&type=script&lang=js&"
export * from "./FormCheckboxBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports